export default __webpack_public_path__ + "static/media/tab-last.65ae9421.svg";